import { useContext } from 'react';
import { EnvironmentContext } from '../contexts/EnvironmentContext';

export const useEnvironmentContext = () => {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error('useEnvironmentContext must be used within an EnvironmentContextProvider');
  }
  return context;
};
